export * from './property-point.component';
